export class DialogData {
  message: string;
  buttonText: {
    ok: string;
    cancel: string;
  };
}